import type { ApiResponse, SignedRequest } from '@shared/types';
import { apiClient } from './client';

export type VpsIdResponse = { vpsId: string };

class ServerAPI {
  async getVpsId(
    signedPayload: SignedRequest<Record<string, never>>,
    serverUrl?: string
  ): Promise<ApiResponse<VpsIdResponse>> {
    return apiClient.signedRequest('/server/vps-id', signedPayload, serverUrl);
  }
}

export const serverAPI = new ServerAPI();
